var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{staticClass:"container__booking container__single"},[_c('section',{staticClass:"form__vertical booking-form form"},_vm._l((_vm.steps),function(step,i){return _c(step.component,{key:i,tag:"component"})}),1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }